<div class="staff-performance-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">People Insights</p>
      <h2>Staff Performance</h2>
      <p class="subtitle">Review payroll output, delivery productivity, earnings distribution, and request pressure in one executive view.</p>
    </div>
    <button mat-stroked-button (click)="loadPerformance()">Refresh</button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="stats-grid">
    <article class="stat-card primary">
      <span>Total Net Pay</span>
      <strong>₦{{ totalNetPay | number:'1.0-0' }}</strong>
      <small>Across generated slips</small>
    </article>
    <article class="stat-card success">
      <span>Total Deliveries</span>
      <strong>{{ totalDeliveries }}</strong>
      <small>Captured in payroll slips</small>
    </article>
    <article class="stat-card accent">
      <span>Average Net Pay</span>
      <strong>₦{{ averageNetPay | number:'1.0-0' }}</strong>
      <small>Average per generated slip</small>
    </article>
    <article class="stat-card warning">
      <span>Payroll Coverage</span>
      <strong>{{ payrollCoverage }}/{{ staff.length }}</strong>
      <small>Staff represented in payroll</small>
    </article>
  </section>

  <section class="content-grid">
    <article class="panel">
      <div class="panel-head">
        <h3>Top Earners</h3>
        <span>By net pay</span>
      </div>
      <div class="metric-list" *ngIf="topEarners.length; else noSlips">
        <div class="metric-row" *ngFor="let row of topEarners">
          <div>
            <strong>{{ row.staffName }}</strong>
            <small>{{ row.position || 'No position' }}</small>
          </div>
          <span>₦{{ row.netAmount | number:'1.0-0' }}</span>
        </div>
      </div>
    </article>

    <article class="panel">
      <div class="panel-head">
        <h3>Top Delivery Staff</h3>
        <span>By deliveries count</span>
      </div>
      <div class="metric-list" *ngIf="topDeliveryStaff.length; else noSlips">
        <div class="metric-row" *ngFor="let row of topDeliveryStaff">
          <div>
            <strong>{{ row.staffName }}</strong>
            <small>{{ row.position || 'No position' }}</small>
          </div>
          <span>{{ row.deliveriesCount }} deliveries</span>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Request Pressure</h3>
        <span>By request type</span>
      </div>
      <div class="metric-list" *ngIf="requestPressure.length; else noRequests">
        <div class="metric-row" *ngFor="let row of requestPressure">
          <strong>{{ row.label }}</strong>
          <span>{{ row.value }}</span>
        </div>
      </div>
    </article>
  </section>
</div>

<ng-template #noSlips>
  <p class="muted">No payroll slips available yet.</p>
</ng-template>

<ng-template #noRequests>
  <p class="muted">No request trend data available yet.</p>
</ng-template>
